import React from 'react';
import { Award } from 'lucide-react';

interface NBIConfigProps {
  config: {
    points: number;
  };
  onChange: (config: { points?: number }) => void;
}

export default function NBIConfig({ config, onChange }: NBIConfigProps) {
  const handlePointsChange = (points: number) => {
    console.log('🏆 NBIConfig - handlePointsChange called');
    console.log('🏆 NBIConfig - new points:', points);
    console.log('🏆 NBIConfig - current config:', config);
    onChange({ points });
  };

  const calculateNBIAmount = () => {
    const result = config.points * 4.92278; // Valeur du point d'indice 2024
    console.log('🏆 NBIConfig - calculateNBIAmount:', {
      points: config.points,
      pointValue: 4.92278,
      result
    });
    return result;
  };

  console.log('🏆 NBIConfig - Rendering with config:', config);

  return (
    <div className="space-y-4">
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">
          <Award className="w-4 h-4 inline mr-1" />
          Nombre de points NBI
        </label>
        <div className="space-y-4">
          <div className="relative">
            <input
              type="range"
              min="15"
              max="120"
              step="1"
              value={config.points}
              onChange={(e) => {
                e.stopPropagation();
                console.log('🏆 NBIConfig - range input onChange triggered');
                console.log('🏆 NBIConfig - new value:', e.target.value);
                handlePointsChange(Number(e.target.value));
              }}
              onClick={(e) => e.stopPropagation()}
              onFocus={(e) => e.stopPropagation()}
              className="w-full h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer"
              style={{
                background: `linear-gradient(to right, #4F46E5 0%, #4F46E5 ${((config.points - 15) / (120 - 15)) * 100}%, #E5E7EB ${((config.points - 15) / (120 - 15)) * 100}%, #E5E7EB 100%)`
              }}
            />
            <div className="flex justify-between text-xs text-gray-500 mt-2">
              <span>15</span>
              <span>30</span>
              <span>45</span>
              <span>60</span>
              <span>75</span>
              <span>90</span>
              <span>105</span>
              <span>120</span>
            </div>
          </div>
          
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-2">
              <div className="p-2 bg-teal-100 rounded-lg">
                <Award className="w-4 h-4 text-teal-600" />
              </div>
              <span className="text-sm font-medium text-gray-700">
                Points NBI sélectionnés
              </span>
            </div>
            <div className="text-right">
              <div className="text-lg font-bold text-teal-600">
                {config.points} points
              </div>
            </div>
          </div>
        </div>
        
        <div className="mt-2 text-xs text-gray-500">
          La NBI varie de 15 à 120 points selon votre poste et vos responsabilités
        </div>
      </div>
    </div>
  );
}